import { FilterDocument } from 'shared/types/filter-document';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';

export const defaultFilterDocument: FilterDocument = {
  sortingMode: SortingMode.CreatedAt,
  groupByMode: GroupByMode.LifeArea,
  filters: {},
};
